import useTranslation from 'next-translate/useTranslation';
import styles from './styles.module.scss';
import FundedAccounts from './FindedAccounts';
import InfoBalance from './InfoBalance';
import Buttons from './Buttons';

export default function NoEmptyWalletModalContent() {
  const { t } = useTranslation('common');

  return (
    <div className={styles.container}>
      <div className={styles.container__wrapper}>
        <InfoBalance />
        <div className={styles['container__wrapper__your-coins']}>
          <div className={styles['container__wrapper__your-coins__title']}>
            <span>{t('noempty_wallet_infoMoney')} </span>
            <span>{t('noempty_wallet_infoMoneyValue')}</span>
          </div>
          <FundedAccounts />
        </div>
      </div>
      <Buttons />
    </div>
  );
}
